export enum BidRecordStatus {
  /**
   * 待委托方确认
   */
  WAIT_ENTRUST_CONFIRM = 0,

  /**
   * 待参与方确认
   */
  WAIT_PARTICIPANT_CONFIRM = 1,

  /**
   * 参与方拒绝价格
   */
  PARTICIPANT_REFUSED = 2,

  /**
   * 待平台确认
   */
  WAIT_PLATFORM_CONFIRM = 3,

  /**
   * 已成交
   */
  DEAL = 4
}

/**
 * 委托方看到的状态说明
 */
export const BidRecordStatusEntrustTextMap = {
  [BidRecordStatus.WAIT_ENTRUST_CONFIRM]: '待确认',
  [BidRecordStatus.WAIT_PARTICIPANT_CONFIRM]: '待参与方确认',
  [BidRecordStatus.PARTICIPANT_REFUSED]: '参与方已拒绝',
  [BidRecordStatus.WAIT_PLATFORM_CONFIRM]: '待平台确认',
  [BidRecordStatus.DEAL]: '已成交'
}

/**
 * 参与方看到的状态说明
 */
export const BidRecordStatusParticipantTextMap = {
  [BidRecordStatus.WAIT_ENTRUST_CONFIRM]: '待委托方确认',
  [BidRecordStatus.WAIT_PARTICIPANT_CONFIRM]: '待确认',
  [BidRecordStatus.PARTICIPANT_REFUSED]: '已拒绝',
  [BidRecordStatus.WAIT_PLATFORM_CONFIRM]: '待平台确认',
  [BidRecordStatus.DEAL]: '已成交'
}

/**
 * 平台看到的状态说明
 */
export const BidRecordStatusPlatformTextMap = {
  [BidRecordStatus.WAIT_ENTRUST_CONFIRM]: '待委托方确认',
  [BidRecordStatus.WAIT_PARTICIPANT_CONFIRM]: '待参与方确认',
  [BidRecordStatus.PARTICIPANT_REFUSED]: '参与方已拒绝',
  [BidRecordStatus.WAIT_PLATFORM_CONFIRM]: '待平台确认',
  [BidRecordStatus.DEAL]: '已成交'
}

export const BidRecordStatusColorMap = {
  [BidRecordStatus.WAIT_ENTRUST_CONFIRM]: 'processing',
  [BidRecordStatus.WAIT_PARTICIPANT_CONFIRM]: 'processing',
  [BidRecordStatus.PARTICIPANT_REFUSED]: 'error',
  [BidRecordStatus.WAIT_PLATFORM_CONFIRM]: 'processing',
  [BidRecordStatus.DEAL]: 'success'
}
